export const formatScore = (score?: number) => {
  const safeScore = score ?? 0;
  if (safeScore === 0) return '0';
  if (Number.isInteger(safeScore)) return String(safeScore);

  const rounded = Math.round(safeScore * 100) / 100; // 둘째 자리까지 반올림
  return String(rounded);
};
